import styled from '@emotion/styled'

export const ConfigWrapper = styled.div`
  display: flex;
  padding-top:100px;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  
  .mappingContainer {
     width: 100%;
     display: flex;
     justify-content: center;
     align-items: center;
     flex-direction: column;
     padding-bottom: 60px;
     .fieldInput {
       width: 100%;
       flex-grow: 4;
       max-width: 400px;
       margin: 20px;
       
       .submitBtn {
          width: 100%;
          font-size: 16px;
       }
     }
  }
`;


export const ConfigListWrapper = styled.div`
  max-width: 600px;
  width: 100%;
  .headingWrapper {
    padding-bottom: 10px;
    border-bottom: 1px solid #282c34;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .listContainer {
    width: 100%;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  
  .buttonWrapper {
    padding: 5px;
  }
`;